import React from 'react';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import useIsMobile from '../../hooks/useIsMobile';
import SummaryPreview from '../banners/SummaryPreview';
import dayjs from '../../config/dayjs';
import GridBorderBox from '../boxes/GridBorderBox';
import FactoringHeaderContent from './FactoringHeaderContent';

const FactoringHeader = ({
  headerTitle,
  headerDescription,
  headerDescriptionProps,
  finder,
  setStates,
  setDates,
  states,
  dates,
  cartType,
  selectionModel,
  setShowConfirmationSummary,
  showConfirmationSummary,
  Filters,
  defaultFilterProps,
  onActionClick,
  useBorderedTitle,
  customFiltersProps,
  onRefresh,
  refreshLoading,
  TopComponent,
  topComponentProps,
  TitleSideComponent,
  titleSideComponentProps,
  showRightComponentInMobile,
}) => {
  const isMobile = useIsMobile('tablet');

  const handleActionClick = (data) => {
    if (onActionClick) {
      onActionClick(data);
    } else {
      setShowConfirmationSummary(!showConfirmationSummary);
    }
  };

  return (
    <Grid container rowSpacing={isMobile ? 1.5 : 4} columnSpacing={isMobile ? 2 : 1} sx={{ width: '100%', pb: isMobile ? 1.5 : 4, pt: 1 }}>
      {TopComponent && (
        <Grid item xs={12} alignItems="center">
          <Box sx={{ width: '100%' }}>
            <TopComponent {...topComponentProps} />
          </Box>
        </Grid>
      )}
      {useBorderedTitle ? (
        <Grid item xs={12}>
          <GridBorderBox isMobile={isMobile}>
            <FactoringHeaderContent
              headerTitle={headerTitle}
              headerDescription={headerDescription}
              headerDescriptionProps={headerDescriptionProps}
              isMobile={isMobile}
              RightComponent={TitleSideComponent
              && <TitleSideComponent {...titleSideComponentProps} finder={finder} />}
              showRightComponentInMobile={showRightComponentInMobile}
            />
          </GridBorderBox>
        </Grid>
      ) : (
        <FactoringHeaderContent
          headerTitle={headerTitle}
          headerDescription={headerDescription}
          headerDescriptionProps={headerDescriptionProps}
          isMobile={isMobile}
          RightComponent={TitleSideComponent
            && <TitleSideComponent {...titleSideComponentProps} finder={finder} />}
          showRightComponentInMobile={showRightComponentInMobile}
        />
      )}
      {selectionModel.length > 0 && !showConfirmationSummary && (
        <Grid item xs={12} md={12}>
          <SummaryPreview cartType={cartType} onActionClick={handleActionClick} />
        </Grid>
      )}
      {!showConfirmationSummary ? (
        Filters && (
          <Filters
            finder={finder}
            setStates={setStates}
            setDates={setDates}
            states={states}
            dates={dates}
            onRefresh={onRefresh}
            refreshLoading={refreshLoading}
            {...defaultFilterProps}
            {...customFiltersProps}
          />
        )
      ) : (
        <Grid item xs={12} md={12}>
          <Divider sx={{ mb: 0, borderColor: 'gray.A300', borderWidth: '1px', borderRadius: '10px' }} />
        </Grid>
      )}
    </Grid>
  );
};

FactoringHeader.propTypes = {
  headerTitle: PropTypes.string.isRequired,
  headerDescription: PropTypes.string,
  headerDescriptionProps: PropTypes.shape({
    variant: PropTypes.string,
    fontWeight: PropTypes.number,
  }),
  finder: PropTypes.shape({
    onFinderChange: PropTypes.func.isRequired,
    searchPlaceHolder: PropTypes.string.isRequired,
    finderValue: PropTypes.string.isRequired,
    canPasteExcel: PropTypes.bool,
    setColumnFilter: PropTypes.func,
  }),
  Filters: PropTypes.elementType,
  setStates: PropTypes.func,
  setDates: PropTypes.func,
  states: PropTypes.shape({
    dateIssued_Gte: PropTypes.string,
    dateIssued_Lte: PropTypes.string,
    availableForFinancing: PropTypes.string,
  }),
  dates: PropTypes.shape({
    dateIssued_Gte: PropTypes.instanceOf(dayjs),
    dateIssued_Lte: PropTypes.instanceOf(dayjs),
  }),
  cartType: PropTypes.string.isRequired,
  selectionModel: PropTypes.arrayOf(PropTypes.string).isRequired,
  setShowConfirmationSummary: PropTypes.func,
  showConfirmationSummary: PropTypes.bool,
  defaultFilterProps: PropTypes.shape(),
  onActionClick: PropTypes.func,
  showRightComponentInMobile: PropTypes.bool,
  customFiltersProps: PropTypes.shape(),
  useBorderedTitle: PropTypes.bool,
  onRefresh: PropTypes.func,
  refreshLoading: PropTypes.bool,
  TopComponent: PropTypes.elementType,
  topComponentProps: PropTypes.shape(),
  TitleSideComponent: PropTypes.elementType,
  titleSideComponentProps: PropTypes.shape(),
};

FactoringHeader.defaultProps = {
  headerDescription: '',
  headerDescriptionProps: null,
  finder: null,
  setStates: () => {},
  setDates: () => {},
  states: {},
  dates: {},
  setShowConfirmationSummary: () => {},
  showConfirmationSummary: false,
  Filters: null,
  defaultFilterProps: {},
  onActionClick: null,
  showRightComponentInMobile: false,
  customFiltersProps: {},
  useBorderedTitle: false,
  onRefresh: undefined,
  refreshLoading: false,
  TopComponent: null,
  topComponentProps: {},
  TitleSideComponent: null,
  titleSideComponentProps: {},
};

export default FactoringHeader;
